/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  CINDER,
  LIGHT_GREY,
  BLACK_PEARL,
  SUNRISE_50,
  WHITE,
  PALE_GRAY,
  BRIGHT_BLUE,
} from 'constants/colors'

export const customStyles = {
  container: (baseStyles) => ({
    ...baseStyles,
    minWidth: '200px',
    width: '100%',
    fontFamily: 'Gibson',
    fontSize: '16px',
    fontStyle: 'normal',
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    color: BLACK_PEARL,
    backgroundColor: WHITE,
    height: '50px',
    paddingLeft: '13px',
    borderTop: `1px solid ${PALE_GRAY}`,
    display: 'flex',
    alignItems: 'center',
    '&:last-of-type': {
      borderBottomLeftRadius: '25px',
      borderBottomRightRadius: '25px',
    },
    '&:hover': {
      backgroundColor: SUNRISE_50,
    },
  }),
  singleValue: (baseStyles, { menuIsOpen }) => ({
    ...baseStyles,
    color: menuIsOpen ? BLACK_PEARL : CINDER,
    fontWeight: '500',
    lineHeight: '40px',
    paddingLeft: '5px',
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: BRIGHT_BLUE,
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    display: 'none',
  }),
  control: (baseStyles, { menuIsOpen }) => ({
    ...baseStyles,
    border: `1px solid ${LIGHT_GREY}`,
    boxShadow: 'none',
    transition: 'none',
    borderRadius: '25px',
    backgroundColor: WHITE,
    height: '50px',
    '&:hover': {
      border: `1px solid ${LIGHT_GREY}`,
    },
    ...(menuIsOpen && {
      borderBottom: 'none',
      borderRadius: '25px 25px 0px 0px',
      '&:hover': {
        borderBottom: 'none',
      },
    }),
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    color: 'transparent',
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    margin: '0px',
    border: `1px solid ${LIGHT_GREY}`,
    borderTop: 'none',
    borderRadius: '0px 0px 25px 25px',
    boxShadow: `0px 3px 6px 0px rgba(33, 37, 41, 0.12)`,
  }),
  menuList: (baseStyles) => ({
    ...baseStyles,
    paddingBottom: '0px',
  }),
}
